(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('momentIsSameOrAfter', momentIsSameOrAfter)

    function momentIsSameOrAfter() {
        function momentIsSameOrAfterFn(value) {
            moment.locale('pt-br');

            var dateStart;

            if (!value)
                return '';

            dateStart = moment(value);

            if (!dateStart.isValid())
                return '';

            return moment().isSameOrAfter(dateStart, null, '[]');
        }

        return momentIsSameOrAfterFn;
    }
}());